import { render } from "./Page-Main.vue?vue&type=template&id=12586c7d"
import script from "./Page-Main.vue?vue&type=script&lang=js"
export * from "./Page-Main.vue?vue&type=script&lang=js"

import "./Page-Main.vue?vue&type=style&index=0&id=12586c7d&lang=css"
script.render = render

export default script